import { Button, Modal } from 'react-bootstrap';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { remindDocusign, sendToDocusign } from 'src/store/actions/contract-actions';
import { faBell } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { toast } from 'react-toastify';
import { IContract } from 'src/types/contract';

interface Props {
    data: IContract;
}

const RemindContractAction: React.FunctionComponent<Props> = ({ data: { id, student } }: Props) => {
    const dispatch = useDispatch();
    const [opened, setOpened] = useState(false);
    const handleClose = () => {
        setOpened(false);
    };
    /* eslint-disable */
    /* eslint jsx-a11y/anchor-is-valid: 0 */
    /* eslint-enable */
    return (
        <>
            <button title={'Remind parents to sign'} type="button" onClick={() => setOpened(true)} className="btn btn-primary">
                <FontAwesomeIcon icon={faBell} />
            </button>
            <Modal show={opened} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Confirmation</Modal.Title>
                </Modal.Header>
                <Modal.Body>Do you want to remind parents by sms and email?</Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Cancel
                    </Button>
                    <Button
                        variant="danger"
                        onClick={() => {
                            handleClose();
                            dispatch(
                                remindDocusign(
                                    { id: id, statusDocusign: 2, student: student?.id },
                                    {
                                        resolve: () => {
                                            toast.success('Remind was successfully sent to parent');
                                        },
                                        reject: (errorMessage: string) => {
                                            toast.error(errorMessage);
                                        },
                                    },
                                ),
                            );
                        }}
                    >
                        Yes
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default RemindContractAction;
